import React from 'react'

import { ExternalContent } from '@hozana/dom/components/ExternalContent'
import { useScreen } from '@hozana/screen/useScreen'
import { QA } from '@hozana/tests/constants'

import { Cell } from 'elements/layout/Cell'
import { Div } from 'elements/layout/Div'
import { Row } from 'elements/layout/Row'
import { H } from 'elements/text/H'
import { Text } from 'elements/text/Text'
import { Accordion } from 'elements/ui/Accordion'

import { ShareFaq, TShareFaqProps } from './ShareFaq'

export type TFaqCategoryProps = {
  questions: TShareFaqProps['question'][]
  category: string
}

export const FaqCategory: TFC<TFaqCategoryProps> = ({ questions, category }) => {
  const screen = useScreen()

  const getTranslationFaqCategoryTitle = () => {
    switch (category) {
      case 'account':
        return 'trans:home:home.faq.title.account'
      case 'animators':
        return 'trans:home:home.faq.title.animators'
      case 'frequent':
        return 'trans:home:home.faq.title.frequent'
      case 'head':
        return 'trans:home:home.faq.title.head'
      case 'other':
        return 'trans:home:home.faq.title.other'
      default:
        return ''
    }
  }

  return (
    <>
      <H data-testid={QA.FAQ.CATEGORY_TITLE} fontSize={{ xs: '1.5em', sm: '2em' }} p="1em 0 1em" color="darkBlue">
        {getTranslationFaqCategoryTitle()}
      </H>
      <Accordion>
        {questions?.reduce(
          (acc, question) => [
            ...acc,
            <Accordion.Header
              key={`${question.id}-header`}
              render={({ isOpen, toggle }) => (
                <Row gutter="10px">
                  <Cell flex="1">
                    <Accordion.Button
                      isOpen={isOpen}
                      onClick={toggle}
                      nowrap={false}
                      m="0"
                      data-testid={QA.FAQ.QUESTION_HEADER}
                    >
                      {question.title}
                    </Accordion.Button>
                  </Cell>
                  {!screen.xs && (
                    <Cell align="middle">
                      <ShareFaq question={question} />
                    </Cell>
                  )}
                </Row>
              )}
            />,
            <Accordion.Content
              data-testid={QA.FAQ.ACCORDION_CONTENT}
              maxHeight="1500px"
              key={`${question.id}-content`}
              scrollable
            >
              <Div p="1em 5px 0" align="left">
                <ExternalContent.StaticPage content={question.answer} imageWithBorder />
                {screen.xs && (
                  <Row gutter="10px" align="middleCenter">
                    <Cell>
                      <ShareFaq question={question} color="black50" />
                    </Cell>
                    <Cell flex="1">
                      <Text italic color="black70">
                        trans:home:share.copy-link
                      </Text>
                    </Cell>
                  </Row>
                )}
              </Div>
            </Accordion.Content>,
          ],
          [],
        )}
      </Accordion>
    </>
  )
}
